/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowDoNextStepResponse
 */
export interface WorkflowDoNextStepResponse {
    /**
     * 
     * @type {number}
     * @memberof WorkflowDoNextStepResponse
     */
    _return: number;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDoNextStepResponse
     */
    infotext: string;
}

export function WorkflowDoNextStepResponseFromJSON(json: any): WorkflowDoNextStepResponse {
    return WorkflowDoNextStepResponseFromJSONTyped(json, false);
}

export function WorkflowDoNextStepResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDoNextStepResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '_return': json['return'],
        'infotext': json['infotext'],
    };
}

export function WorkflowDoNextStepResponseToJSON(value?: WorkflowDoNextStepResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'return': value._return,
        'infotext': value.infotext,
    };
}


